"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _moment = _interopRequireDefault(require("moment"));

var _Creator = _interopRequireDefault(require("../../Creator"));

var _getIframeSrc = _interopRequireDefault(require("../utils/getIframeSrc"));

var _Votes = _interopRequireDefault(require("../../Votes"));

var _Tags = _interopRequireDefault(require("../../Tags"));

var _ViewPostContentPlaceholder = _interopRequireDefault(require("./ViewPostContentPlaceholder"));

require("../styles/_view-post-modal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ViewPostModal = /*#__PURE__*/function (_Component) {
  _inherits(ViewPostModal, _Component);

  function ViewPostModal(props) {
    var _this;

    _classCallCheck(this, ViewPostModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ViewPostModal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "fetchInspiration", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getInspiration, fetchAssets, inspirationId, isVisible, selectedInspirationOrgId, setSelectedOrgId, _ref2, data, error, organisationId;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, getInspiration = _this$props.getInspiration, fetchAssets = _this$props.fetchAssets, inspirationId = _this$props.inspirationId, isVisible = _this$props.isVisible, selectedInspirationOrgId = _this$props.selectedInspirationOrgId, setSelectedOrgId = _this$props.setSelectedOrgId;

              if (inspirationId) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return getInspiration(inspirationId);

            case 5:
              _ref2 = _context.sent;
              data = _ref2.data;
              error = _ref2.error;

              if (!(!data || !data.getInspiration || error)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: true
              }));

            case 10:
              organisationId = data.getInspiration.organisationId;

              if (isVisible && setSelectedOrgId && organisationId !== selectedInspirationOrgId) {
                setSelectedOrgId(organisationId);
              }

              fetchAssets(data.getInspiration);

              _this.setState({
                post: data.getInspiration
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "renderPostContent", function () {
      var overrideStatus = _this.props.overrideStatus;
      var openReportModal = _this.props.openReportModal;
      var _this$state = _this.state,
          post = _this$state.post,
          error = _this$state.error;

      var _ref3 = post || {},
          _ref3$status = _ref3.status,
          status = _ref3$status === void 0 ? '' : _ref3$status;

      var isNotFound = post === null || status === 'DRAFT' && !overrideStatus;

      if (isNotFound) {
        return _react.default.createElement("div", {
          className: "view-post-modal__not-found"
        }, _react.default.createElement("div", {
          className: "view-post-modal__not-found__inner"
        }, _react.default.createElement(_uiKit.Icon, {
          className: "view-post-modal__not-found__icon",
          size: 80,
          name: "robot"
        }), _react.default.createElement("div", {
          className: "view-post-modal__not-found__text"
        }, _react.default.createElement("p", {
          className: "view-post-modal__not-found__header"
        }, "Hmm.. you seem to be lost."), _react.default.createElement("p", {
          className: "view-post-modal__not-found__suggest"
        }, 'This inspiration post doesn\'t seem to exist.'))));
      }

      if (error) {
        return _react.default.createElement("div", {
          className: "view-post-modal__error"
        }, _react.default.createElement("div", null, "Something went wrong. Try reopening the post."));
      }

      if (!post) {
        return _react.default.createElement("div", {
          className: "view-post-modal__loading"
        }, _react.default.createElement(_ViewPostContentPlaceholder.default, {
          className: "view-post-modal__loading__content"
        }));
      }

      var inspirationId = post.inspirationId,
          title = post.title,
          description = post.description,
          referenceLink = post.referenceLink,
          assetId = post.assetId,
          embedCode = post.embedCode,
          createdAt = post.createdAt,
          tagLine = post.tagLine,
          upVotes = post.upVotes,
          downVotes = post.downVotes,
          currentUserVote = post.currentUserVote,
          createdByUser = post.createdByUser;
      var date = (0, _moment.default)(createdAt).format('Do MMMM YYYY [at] hh:mm A');
      return _react.default.createElement("div", {
        className: "view-post-modal__media-content"
      }, _react.default.createElement("div", {
        className: "view-post-modal__media-content__video-block"
      }, embedCode ? _react.default.createElement("div", {
        className: "view-post-modal__media-content__video-block__embed"
      }, _react.default.createElement("iframe", {
        title: "inspiration iframe",
        src: (0, _getIframeSrc.default)(embedCode),
        allowFullScreen: true
      })) : _react.default.createElement(_commonReact.Player, {
        assetId: assetId
      }), _react.default.createElement("div", {
        className: "view-post-modal__media-content__video-block__footer"
      }, _react.default.createElement("div", {
        className: "view-post-modal__media-content__video-block__footer__actions"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "report",
        color: "regent",
        size: 22.5,
        onClick: openReportModal,
        hoverColor: "redApple"
      })))), _react.default.createElement("div", {
        className: "view-post-modal__media-content__description"
      }, _react.default.createElement("div", {
        className: "view-post-modal__media-content__description__header"
      }, _react.default.createElement(_uiKit.Text, {
        heading5: true
      }, title)), _react.default.createElement("div", {
        className: "view-post-modal__media-content__description__date"
      }, _react.default.createElement(_uiKit.Text, {
        timestamp: true,
        noMargin: true
      }, date), _react.default.createElement(_Votes.default, {
        inspirationId: inspirationId,
        upVotes: upVotes,
        downVotes: downVotes,
        currentUserVote: currentUserVote,
        hideTotal: true
      })), _react.default.createElement(_uiKit.Text, null, description), _react.default.createElement(_Tags.default, {
        tags: tagLine
      }), _react.default.createElement(_Creator.default, {
        creator: createdByUser,
        imageSize: 25,
        placeholderTextSize: 8,
        fontSize: 12
      }), referenceLink && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("hr", null), _react.default.createElement(_uiKit.Text, {
        label: true
      }, "Related Links"), _react.default.createElement("a", {
        className: "view-post-modal__media-content__description__article__link",
        href: referenceLink.startsWith('http') ? referenceLink : "//".concat(referenceLink),
        target: "_blank",
        rel: "noopener noreferrer"
      }, referenceLink))));
    });

    _this.state = {
      error: false
    };
    return _this;
  }

  _createClass(ViewPostModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          history = _this$props2.history,
          isVisible = _this$props2.isVisible,
          inspirationId = _this$props2.inspirationId;

      if (isVisible) {
        history.push("#".concat(inspirationId));
      }

      this.fetchInspiration();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref4) {
      var prevId = _ref4.inspirationId,
          prevVisible = _ref4.isVisible;
      var _this$props3 = this.props,
          inspirationId = _this$props3.inspirationId,
          history = _this$props3.history,
          location = _this$props3.location,
          isVisible = _this$props3.isVisible;

      if (isVisible !== prevVisible) {
        history.push(isVisible ? "#".concat(inspirationId) : location.pathname);
      }

      if (prevId === inspirationId) {
        return;
      }

      this.fetchInspiration();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props4 = this.props,
          location = _this$props4.location,
          history = _this$props4.history;
      history.push(location.pathname);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          onClose = _this$props5.onClose,
          isVisible = _this$props5.isVisible;
      return _react.default.createElement("div", {
        className: "view-post-modal"
      }, _react.default.createElement(_uiKit.BaseModal, {
        key: "view-post-modal",
        visible: isVisible,
        onClose: onClose
      }, this.renderPostContent()));
    }
  }]);

  return ViewPostModal;
}(_react.Component);

exports.default = ViewPostModal;

_defineProperty(ViewPostModal, "defaultProps", {
  overrideStatus: false
});